<template>
    <div class="c-marquee">
        <div class="c-marquee-text" ref="$marquee" data-marquee-direction="left">
            <div class="c-marquee-text__wrapper" ref="$wrapper">
                <span class="text" v-for="index in amount" :key="index" ref="$text"> {{ text }}</span>
            </div>
        </div>
    </div>
</template>

<script setup>
    const props = defineProps({
        text: {
            type: String,
            default: ""
        },
        amount: {
            type: Number,
            default: 6
        }
    });

    const globalStore = useGlobalStore();

    const ctx = ref(null);
    const $marquee = ref(null);
    const $wrapper = ref(null);
    const $text = ref([]);

    watch(
        () => globalStore.pageTransitionComplete,
        (state) => {
            if (state) {
                nextTick(() => (ctx.value = useCtx(useMarqueeAnimation($marquee.value, $wrapper.value), $marquee.value)));
            }
        }
    );

    onBeforeUnmount(() => {
        if (ctx.value) ctx.value.revert();
    });
</script>
